import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { MessagingProvider } from '.';
import MessagingService from '../../services/MessagingService';
import { useMember } from '../SessionProvider';
import { ChatMessagingStateType, ChatChannelStateType } from './models';
import ImageService from '../../services/ImageService';

const ChatMessagingServiceContext = createContext<MessagingService>(
  {} as MessagingService
);
const ImageServiceContext = createContext<ImageService>({} as ImageService);
const ChatMessagingState = createContext<Partial<ChatMessagingStateType>>({});
const ChatChannelState = createContext<Partial<ChatChannelStateType>>({});
const KaiinChatMessagesProvider: FC<PropsWithChildren> = ({ children }) => {
  const { member } = useMember();
  return (
    <MessagingProvider
      chimeId={member.userId}
      ChatMessagingServiceContext={ChatMessagingServiceContext}
      ImageServiceContext={ImageServiceContext}
      ChatMessagingState={ChatMessagingState}
      ChatChannelState={ChatChannelState}
      loadChannels={false}
    >
      {children}
    </MessagingProvider>
  );
};

const useKaiinChatMessagingService = () =>
  useContext(ChatMessagingServiceContext);
const useKaiinImageService = () => useContext(ImageServiceContext);
const useKaiinChatMessagingState = () =>
  useContext(ChatMessagingState) as ChatMessagingStateType;
const useKaiinChatChannelState = () =>
  useContext(ChatChannelState) as ChatChannelStateType;

export {
  KaiinChatMessagesProvider,
  useKaiinChatMessagingService,
  useKaiinImageService,
  useKaiinChatMessagingState,
  useKaiinChatChannelState
};
